<template>
  <svg
    v-if="icon === 'button-add'"
    :width="width ? width : 16"
    :height="height ? height : 16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0C3.58862 0 0 3.58862 0 8C0 12.4114 3.58862 16 8 16C12.4114 16 16 12.4114 16 8C16 3.58862 12.4114 0 8 0ZM11.5 8.66663H8.66663V11.5C8.66663 11.868 8.36804 12.1666 8 12.1666C7.63196 12.1666 7.33337 11.868 7.33337 11.5V8.66663H4.5C4.13196 8.66663 3.83337 8.36804 3.83337 8C3.83337 7.63196 4.13196 7.33337 4.5 7.33337H7.33337V4.5C7.33337 4.13196 7.63196 3.83337 8 3.83337C8.36804 3.83337 8.66663 4.13196 8.66663 4.5V7.33337H11.5C11.868 7.33337 12.1666 7.63196 12.1666 8C12.1666 8.36804 11.868 8.66663 11.5 8.66663Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-add-v2'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 6H14V8H0V6Z" :fill="color" />
    <path d="M8 8.74224e-08L8 14H6L6 0L8 8.74224e-08Z" :fill="color" />
  </svg>
  <svg
    v-else-if="icon === 'button-edit'"
    :width="width ? width : 19"
    :height="height ? height : 19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="color"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-save'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M6.99991 10.4999C6.88032 10.4999 6.76599 10.4509 6.68374 10.3646L3.62124 7.15625C3.35582 6.87859 3.55299 6.41659 3.93741 6.41659H5.54157V3.06242C5.54157 2.6605 5.86882 2.33325 6.27074 2.33325H7.72907C8.13099 2.33325 8.45824 2.6605 8.45824 3.06242V6.41659H10.0624C10.4468 6.41659 10.644 6.87859 10.3786 7.15625L7.31607 10.3646C7.23382 10.4509 7.11949 10.4999 6.99991 10.4999Z"
        :fill="color"
      />
      <path
        d="M12.25 13.9999H1.75C0.785167 13.9999 0 13.2147 0 12.2499V9.33325C0 8.36842 0.785167 7.58325 1.75 7.58325H2.625C2.947 7.58325 3.20833 7.84458 3.20833 8.16658C3.20833 8.48858 2.947 8.74992 2.625 8.74992H1.75C1.42858 8.74992 1.16667 9.01183 1.16667 9.33325V12.2499C1.16667 12.5713 1.42858 12.8332 1.75 12.8332H12.25C12.5714 12.8332 12.8333 12.5713 12.8333 12.2499V9.33325C12.8333 9.01183 12.5714 8.74992 12.25 8.74992H11.375C11.053 8.74992 10.7917 8.48858 10.7917 8.16658C10.7917 7.84458 11.053 7.58325 11.375 7.58325H12.25C13.2148 7.58325 14 8.36842 14 9.33325V12.2499C14 13.2147 13.2148 13.9999 12.25 13.9999Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'button-create_pdf'"
    :width="width ? width : 25"
    :height="height ? height : 24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M12.0927 5.99934H8.41989V0.00271703H8.73097C10.944 0.00271703 13.1564 0.00721732 15.3689 -0.0012207C15.8667 -0.0012207 16.2689 0.151226 16.6233 0.510686C18.911 2.81183 21.2048 5.10547 23.5048 7.39162C23.6678 7.54581 23.7964 7.73261 23.8824 7.93983C23.9683 8.14705 24.0097 8.37005 24.0038 8.59432C23.9989 12.8876 23.9976 17.1816 23.9998 21.4764C23.9998 22.9952 22.9963 23.9971 21.4797 23.9982C16.7641 24.0008 12.0482 24.0008 7.33194 23.9982C5.80748 23.9982 4.80054 22.9823 4.80054 21.4556C4.80054 19.4591 4.80054 17.4616 4.79548 15.4657C4.78768 15.2437 4.86222 15.0268 5.00474 14.8565C7.28825 12.0134 9.56727 9.16754 11.8418 6.31886C11.9138 6.23167 11.9802 6.14279 12.0927 5.99934ZM15.6192 8.37605H21.4982L15.6181 2.50206L15.6192 8.37605ZM12.8892 20.3952C13.4056 20.3952 13.9018 20.4059 14.3968 20.3952C15.4319 20.3682 16.1637 19.7972 16.3854 18.7858C16.5887 17.8766 16.5876 16.9335 16.382 16.0248C16.1868 15.1704 15.6541 14.5656 14.7568 14.4497C14.1499 14.3716 13.5249 14.4351 12.8892 14.4351V20.3952ZM9.52695 18.2941C9.83466 18.2941 10.0974 18.3014 10.3589 18.2941C11.259 18.2637 11.9121 17.767 12.0465 16.944C12.1114 16.5669 12.1089 16.1812 12.0392 15.8049C11.898 15.1 11.4711 14.5521 10.7364 14.4683C9.97361 14.3817 9.19337 14.4492 8.42045 14.4492V20.3822H9.52527L9.52695 18.2941ZM20.1814 16.944H18.4594V15.4077H20.3827V14.4227H17.3332V20.38H18.442V17.9521H20.1814V16.944Z"
        :fill="color"
      />
      <path
        d="M-0.00170898 7.20325H2.3885V0.0185547H7.19874V7.19257H9.60639L4.80009 13.2004L-0.00170898 7.20325Z"
        :fill="color"
      />
      <path
        d="M14.0195 15.4485C14.856 15.3124 15.265 15.5779 15.3274 16.3823C15.3791 17.0731 15.3776 17.7669 15.3229 18.4575C15.2627 19.231 14.8228 19.5095 14.0195 19.3576"
        :fill="color"
      />
      <path
        d="M9.54297 17.2957V15.4034C9.97781 15.4889 10.483 15.2098 10.7912 15.6942C11.0528 16.1054 11.0871 16.5835 10.8216 17.0004C10.5111 17.4881 9.99074 17.2164 9.54297 17.2957Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'button-send'"
    :width="width ? width : '18'"
    :height="height ? height : '18'"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7825 0.217449C17.6813 0.116704 17.5534 0.046952 17.4139 0.0163941C17.2744 -0.0141638 17.1291 -0.00425713 16.995 0.0449493L0.495001 6.04495C0.352702 6.09892 0.230191 6.19491 0.143739 6.32016C0.0572872 6.44542 0.0109863 6.59401 0.0109863 6.7462C0.0109863 6.89839 0.0572872 7.04698 0.143739 7.17223C0.230191 7.29749 0.352702 7.39348 0.495001 7.44745L6.9375 10.0199L11.6925 5.24995L12.75 6.30745L7.9725 11.0849L10.5525 17.5275C10.6081 17.667 10.7043 17.7866 10.8286 17.8709C10.953 17.9551 11.0998 18.0001 11.25 17.9999C11.4016 17.9968 11.5486 17.9479 11.6718 17.8595C11.795 17.7711 11.8885 17.6475 11.94 17.5049L17.94 1.00495C17.9911 0.872257 18.0034 0.727772 17.9755 0.588342C17.9477 0.448912 17.8807 0.320282 17.7825 0.217449Z"
      :fill="color !== '#F2F2F2' ? color : 'currentColor'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-done'"
    :width="width ? width : 11"
    :height="height ? height : 8"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.47672 0.26763C8.64904 0.0968096 8.88167 0.000672966 9.12431 3.51967e-06C9.36695 -0.000665926 9.60011 0.0941856 9.77337 0.264052C9.94663 0.433918 10.0461 0.665151 10.0502 0.907757C10.0544 1.15036 9.96284 1.38485 9.79547 1.56052L4.88001 7.70484C4.79553 7.79584 4.69357 7.86886 4.58022 7.91955C4.46688 7.97023 4.34447 7.99754 4.22033 7.99984C4.09619 8.00214 3.97286 7.97938 3.85771 7.93293C3.74256 7.88647 3.63797 7.81727 3.55018 7.72947L0.293318 4.47138C0.202585 4.38683 0.129811 4.28488 0.0793366 4.1716C0.0288621 4.05832 0.00172117 3.93603 -0.000466631 3.81203C-0.00265443 3.68803 0.0201557 3.56487 0.0666026 3.44987C0.11305 3.33488 0.182182 3.23042 0.269875 3.14273C0.357569 3.05504 0.462027 2.98591 0.577018 2.93946C0.69201 2.89301 0.815179 2.8702 0.939177 2.87239C1.06317 2.87458 1.18546 2.90172 1.29874 2.95219C1.41202 3.00267 1.51398 3.07544 1.59852 3.16617L4.17692 5.74334L8.45332 0.294719C8.46095 0.285181 8.46918 0.276133 8.47795 0.26763H8.47672Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-continue'"
    :width="width ? width : 17"
    :height="height ? height : 10"
    viewBox="0 0 17 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5393 0.209802C11.6051 0.143298 11.6833 0.0905335 11.7693 0.0545322C11.8554 0.0185308 11.9476 0 12.0408 0C12.1339 0 12.2262 0.0185308 12.3122 0.0545322C12.3983 0.0905335 12.4764 0.143298 12.5422 0.209802L16.7919 4.49458C16.8579 4.56092 16.9102 4.63972 16.9459 4.72648C16.9816 4.81324 17 4.90625 17 5.00019C17 5.09412 16.9816 5.18713 16.9459 5.27389C16.9102 5.36065 16.8579 5.43946 16.7919 5.50579L12.5422 9.79057C12.4092 9.92467 12.2289 10 12.0408 10C11.8527 10 11.6723 9.92467 11.5393 9.79057C11.4063 9.65648 11.3316 9.47461 11.3316 9.28497C11.3316 9.09533 11.4063 8.91346 11.5393 8.77936L15.2889 5.00019L11.5393 1.22101C11.4733 1.15467 11.421 1.07587 11.3853 0.989109C11.3496 0.902349 11.3312 0.809339 11.3312 0.715406C11.3312 0.621474 11.3496 0.528463 11.3853 0.441704C11.421 0.354944 11.4733 0.276139 11.5393 0.209802Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 5.00019C0 4.81079 0.0746223 4.62915 0.207451 4.49522C0.340279 4.3613 0.520433 4.28606 0.708281 4.28606H15.5822C15.77 4.28606 15.9502 4.3613 16.083 4.49522C16.2158 4.62915 16.2905 4.81079 16.2905 5.00019C16.2905 5.18959 16.2158 5.37123 16.083 5.50515C15.9502 5.63908 15.77 5.71432 15.5822 5.71432H0.708281C0.520433 5.71432 0.340279 5.63908 0.207451 5.50515C0.0746223 5.37123 0 5.18959 0 5.00019Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-confirm'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0C3.13078 0 0 3.13111 0 7C0 10.8692 3.13111 14 7 14C10.8692 14 14 10.8689 14 7C14 3.13078 10.8689 0 7 0ZM7 13.0667C3.65485 13.0667 0.933324 10.3452 0.933324 7C0.933324 3.65482 3.65485 0.933324 7 0.933324C10.3452 0.933324 13.0667 3.65485 13.0667 7C13.0667 10.3452 10.3452 13.0667 7 13.0667Z"
      :fill="color"
    />
    <path
      d="M10.7058 4.42782C10.5236 4.24558 10.2281 4.24558 10.0459 4.42782L5.89134 8.58234L3.95486 6.64589C3.77261 6.46364 3.47711 6.46364 3.29489 6.64589C3.11264 6.82813 3.11264 7.12361 3.29489 7.30585L5.56133 9.57229C5.74355 9.75451 6.03913 9.75445 6.2213 9.57229L10.7058 5.08776C10.8881 4.90552 10.8881 4.61007 10.7058 4.42782Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-delete'"
    :width="width ? width : 20"
    :height="height ? height : 21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99995 0.5C10.8233 0.499884 11.617 0.807566 12.2251 1.36263C12.8332 1.9177 13.2119 2.68005 13.2868 3.5H18.4C18.628 3.50007 18.8475 3.58669 19.0141 3.74237C19.1807 3.89804 19.282 4.11116 19.2976 4.33866C19.3131 4.56615 19.2417 4.79107 19.0978 4.96796C18.9539 5.14485 18.7482 5.26052 18.5223 5.2916L18.4 5.3H17.7003L16.1799 18.476C16.1122 19.0609 15.8319 19.6005 15.3922 19.9921C14.9526 20.3837 14.3843 20.6001 13.7956 20.6H6.20435C5.61557 20.6001 5.0473 20.3837 4.60765 19.9921C4.16801 19.6005 3.88766 19.0609 3.81995 18.476L2.29835 5.3H1.59995C1.38247 5.29999 1.17234 5.22123 1.00843 5.07828C0.844528 4.93533 0.737929 4.73786 0.708351 4.5224L0.699951 4.4C0.69996 4.18251 0.778722 3.97239 0.921672 3.80848C1.06462 3.64458 1.26209 3.53798 1.47755 3.5084L1.59995 3.5H6.71315C6.788 2.68005 7.16667 1.9177 7.7748 1.36263C8.38293 0.807566 9.17659 0.499884 9.99995 0.5ZM8.19995 8C7.90595 8 7.65995 8.186 7.60955 8.4308L7.59995 8.5256V15.8756L7.60955 15.9692C7.65995 16.214 7.90595 16.4 8.19995 16.4C8.49395 16.4 8.73995 16.214 8.79035 15.9692L8.79995 15.8744V8.5268L8.79035 8.4308C8.73995 8.1872 8.49395 8 8.19995 8ZM11.8 8C11.506 8 11.26 8.186 11.2096 8.4308L11.2 8.5256V15.8756L11.2096 15.9692C11.26 16.214 11.506 16.4 11.8 16.4C12.094 16.4 12.3399 16.214 12.3904 15.9692L12.4 15.8744V8.5268L12.3904 8.4308C12.3399 8.1872 12.094 8.0012 11.8 8.0012V8ZM9.99995 2.3C9.27395 2.3 8.66795 2.816 8.52995 3.5H11.47C11.3308 2.816 10.726 2.3 9.99995 2.3Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-show'"
    :width="width ? width : 24"
    :height="height ? height : 16"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.846924C7.41454 0.846924 3.25621 3.35567 0.187788 7.43054C-0.0625959 7.76438 -0.0625959 8.23078 0.187788 8.56463C3.25621 12.6444 7.41454 15.1532 12 15.1532C16.5855 15.1532 20.7438 12.6444 23.8122 8.56954C24.0626 8.23569 24.0626 7.76929 23.8122 7.43545C20.7438 3.35567 16.5855 0.846924 12 0.846924ZM12.3289 13.0372C9.28506 13.2286 6.7714 10.7199 6.96287 7.6711C7.11998 5.15745 9.15741 3.12001 11.6711 2.96291C14.7149 2.77144 17.2286 5.28019 17.0371 8.32897C16.8751 10.8377 14.8377 12.8752 12.3289 13.0372ZM12.1767 10.7101C10.537 10.8132 9.18196 9.46306 9.28997 7.8233C9.37343 6.46828 10.4732 5.37347 11.8282 5.2851C13.4679 5.182 14.823 6.5321 14.7149 8.17187C14.6266 9.5318 13.5268 10.6266 12.1767 10.7101Z"
      :fill="color !== '#F2F2F2' ? color : '#2F80ED'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-hide'"
    :width="width ? width : 24"
    :height="height ? height : 16"
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9555 0L3.9516 16H7.9682L19.9721 0H15.9555Z"
      :fill="color !== '#F2F2F2' ? color : '#2F80ED'"
    />
    <path
      d="M11.9999 0.846924C12.7365 0.846924 13.4619 0.911621 14.1738 1.03723L12.7001 3.00122C12.3664 2.95471 12.0222 2.9408 11.6711 2.96289C9.15741 3.12 7.11981 5.15747 6.96283 7.67114C6.90887 8.52991 7.06952 9.34595 7.39642 10.0708L5.09711 13.1355C3.26996 12.0126 1.61151 10.4578 0.187683 8.56458C-0.062561 8.23083 -0.062561 7.7644 0.187683 7.43054C3.25604 3.35571 7.41449 0.846924 11.9999 0.846924Z"
      :fill="color !== '#F2F2F2' ? color : '#2F80ED'"
    />
    <path
      d="M12.3288 13.0372C11.9641 13.0601 11.6069 13.0443 11.2609 12.9934L9.78851 14.9561C10.5121 15.0861 11.2504 15.1532 11.9999 15.1532C16.5854 15.1532 20.7438 12.6444 23.8122 8.56958C24.0624 8.23572 24.0624 7.76929 23.8122 7.43542C22.3808 5.53223 20.7121 3.97083 18.8735 2.84656L16.5873 5.8938C16.925 6.62744 17.0917 7.45605 17.037 8.32898C16.8749 10.8376 14.8376 12.8752 12.3288 13.0372Z"
      :fill="color !== '#F2F2F2' ? color : '#2F80ED'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-email'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width ? width : '1em'"
    :height="height ? height : '1em'"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 36 36"
  >
    <path
      class="clr-i-solid clr-i-solid-path-1"
      d="M32.33 6a2 2 0 0 0-.41 0h-28a2 2 0 0 0-.53.08l14.45 14.39z"
      :fill="color !== '#F2F2F2' ? color : 'currentColor'"
    />
    <path
      class="clr-i-solid clr-i-solid-path-2"
      d="M33.81 7.39l-14.56 14.5a2 2 0 0 1-2.82 0L2 7.5a2 2 0 0 0-.07.5v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V8a2 2 0 0 0-.12-.61zM5.3 28H3.91v-1.43l7.27-7.21l1.41 1.41zm26.61 0h-1.4l-7.29-7.23l1.41-1.41l7.27 7.21z"
      :fill="color !== '#F2F2F2' ? color : 'currentColor'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-phone'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width ? width : '1em'"
    :height="height ? height : '1em'"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      d="M20.487 17.14l-4.065-3.696a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66c-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.085-1.39z"
      :fill="color !== '#F2F2F2' ? color : 'currentColor'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-contact'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width ? width : '1em'"
    :height="height ? height : '1em'"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4z"
      :fill="color ? color : 'currentColor'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-address'"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width ? width : '1em'"
    :height="height ? height : '1em'"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 18 24"
  >
    <path
      d="M8.075 23.52C1.264 13.642 0 12.629 0 9c0-4.971 4.029-9 9-9s9 4.029 9 9c0 3.629-1.264 4.64-8.075 14.516a1.126 1.126 0 0 1-1.847.004l-.002-.004zM9 12.75a3.75 3.75 0 1 0 0-7.5A3.75 3.75 0 0 0 9 12.75z"
      :fill="color !== '#F2F2F2' ? color : 'currentColor'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-pdf'"
    :width="width ? width : '12'"
    :height="height ? height : '14'"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.08007 10.5H2.41434V11.375H3.08007C3.32972 11.375 3.49615 11.2 3.49615 10.9375C3.49615 10.675 3.32972 10.5 3.08007 10.5ZM7.40734 0H0.75V14H11.5682V4.375L7.40734 0ZM4.2451 11.025C4.2451 11.725 3.7458 12.25 3.08007 12.25H2.41434V13.125H1.58217V9.625H3.08007C3.7458 9.625 4.2451 10.15 4.2451 10.85V11.025ZM7.65699 11.4625C7.65699 12.3375 6.99126 13.125 6.07587 13.125H4.91084V9.625H6.07587C6.90804 9.625 7.65699 10.325 7.65699 11.2875V11.4625ZM10.736 10.5H9.07168V11.375H10.3199V12.25H9.07168V13.125H8.23951V9.625H10.736V10.5ZM10.736 8.75H1.58217V0.875H7.40734V4.375H10.736V8.75ZM6.07587 10.5H5.74301V12.25H6.07587C6.57517 12.25 6.90804 11.9 6.90804 11.375C6.90804 10.85 6.49196 10.5 6.07587 10.5Z"
      :fill="color !== '#F2F2F2' ? color : 'currentColor'"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-back'"
    :width="width ? width : 16"
    :height="height ? height : 16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.66648 1.33328C6.6666 1.19424 6.62326 1.05865 6.5425 0.945471C6.46175 0.832293 6.34763 0.747194 6.21612 0.702083C6.08461 0.656972 5.94228 0.654107 5.80906 0.693888C5.67584 0.73367 5.55839 0.814108 5.47314 0.923945L0.806478 6.92394C0.715442 7.04097 0.666016 7.18501 0.666016 7.33328C0.666016 7.48155 0.715442 7.62558 0.806478 7.74261L5.47314 13.7426C5.55839 13.8524 5.67584 13.9329 5.80906 13.9727C5.94228 14.0125 6.08461 14.0096 6.21612 13.9645C6.34763 13.9194 6.46175 13.8343 6.5425 13.7211C6.62326 13.6079 6.6666 13.4723 6.66648 13.3333V10.6733C10.2525 10.7479 11.9751 11.4286 12.8405 12.1686C13.6631 12.8719 13.8138 13.6993 13.9705 14.5659L14.0111 14.7893C14.0411 14.9491 14.1283 15.0924 14.2566 15.1924C14.3848 15.2924 14.5451 15.342 14.7074 15.332C14.8697 15.322 15.0227 15.2531 15.1377 15.1381C15.2527 15.0232 15.3217 14.8702 15.3318 14.7079C15.4458 12.8759 15.2745 10.2213 13.9805 8.00061C12.7245 5.84528 10.4625 4.18794 6.66648 4.01461V1.33328Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-add_report'"
    :width="width ? width : 14"
    :height="height ? height : 16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5718 12.1551H1.11155C0.498619 12.1551 0 11.6758 0 11.0868V1.06832C0 0.479223 0.498619 0 1.11155 0H5.92829V2.49274C5.92829 3.08183 6.42691 3.56106 7.03985 3.56106H9.63348V9.5551C8.45685 9.63001 7.5266 10.571 7.5266 11.7208C7.5266 11.8696 7.54216 12.0148 7.5718 12.1551ZM7.03985 5.00922H2.59363C2.38883 5.00922 2.22311 5.16849 2.22311 5.36533C2.22311 5.56216 2.38883 5.72143 2.59363 5.72143H7.03985C7.24465 5.72143 7.41037 5.56216 7.41037 5.36533C7.41037 5.16849 7.24465 5.00922 7.03985 5.00922ZM7.03985 6.43364H2.59363C2.38883 6.43364 2.22311 6.59292 2.22311 6.78975C2.22311 6.98658 2.38883 7.14585 2.59363 7.14585H7.03985C7.24465 7.14585 7.41037 6.98658 7.41037 6.78975C7.41037 6.59292 7.24465 6.43364 7.03985 6.43364ZM7.03985 7.85806H2.59363C2.38883 7.85806 2.22311 8.01734 2.22311 8.21417C2.22311 8.411 2.38883 8.57028 2.59363 8.57028H7.03985C7.24465 8.57028 7.41037 8.411 7.41037 8.21417C7.41037 8.01734 7.24465 7.85806 7.03985 7.85806ZM5.55778 9.28249H2.59363C2.38883 9.28249 2.22311 9.44176 2.22311 9.63859C2.22311 9.83542 2.38883 9.9947 2.59363 9.9947H5.55778C5.76257 9.9947 5.92829 9.83542 5.92829 9.63859C5.92829 9.44176 5.76257 9.28249 5.55778 9.28249Z"
      :fill="color"
    />
    <path d="M8.42993 12.8107H14V13.6081H8.42993V12.8107Z" :fill="color" />
    <path
      d="M11.6128 10.4187L11.6128 16.0001H10.8171L10.8171 10.4187L11.6128 10.4187Z"
      :fill="color"
    />
    <path
      d="M7.03995 2.84869H9.41648L6.66943 0.208496V2.49258C6.66943 2.68906 6.83552 2.84869 7.03995 2.84869Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-copy'"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    :width="width ? width : 20"
    :height="height ? height : 20"
    viewBox="0 0 45 35"
    xml:space="preserve"
    class="copy"
  >
    <polyline
      fill="none"
      points="3,21 14,35 41,1 "
      :stroke="color !== '#F2F2F2' ? color : 'currentColor'"
      stroke-width="5"
      stroke-dasharray="200"
      stroke-dashoffset="200"
      stroke-linecap="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-cross'"
    :width="width ? width : 14"
    :height="height ? height : 14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6677 2.33438L2.33441 11.6677M11.6677 11.6677L2.33441 2.33438L11.6677 11.6677Z"
      :stroke="color"
      stroke-width="2"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-upload'"
    :width="width ? width : 20"
    :height="height ? height : 20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M5 8L10 13M10 13L15 8M10 13V1"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      style="fill: none !important"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-download'"
    :width="width ? width : 20"
    :height="height ? height : 20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M15 6L10 1M10 1L5 6M10 1V13"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else-if="icon === 'button-repeat'"
    :width="width ? width : 16"
    :height="height ? height : 16"
    :fill="color"
    viewBox="0 0 16 16"
  >
    <path
      d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
    ></path>
    <path
      fill-rule="evenodd"
      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
    ></path>
  </svg>
  <svg
    v-else-if="icon === 'button-exit'"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color"
      d="M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'iconsButton',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#F2F2F2',
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
.copy {
  polyline {
    animation: anim;
    animation-duration: 2s;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;

    -moz-animation: anim;
    -moz-animation-duration: 2s;
    -moz-animation-delay: 0.3s;
    -moz-animation-fill-mode: forwards;
    -moz-animation-timing-function: ease-out;
  }

  @keyframes anim {
    0% {
      stroke-dashoffset: 200;
    }
    50% {
      stroke-dashoffset: 50;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
}

svg {
  path {
    transition: 0.3s !important;
  }
}
</style>
